var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile_card_wrapper"},[_c('img',{attrs:{"loading":"lazy","src":_vm.imageSrc,"alt":""}}),(_vm.editable)?_c('span',{staticClass:"profile_icon"},[_c('IconChip',{attrs:{"shadow":"","icon":"mdi-camera"}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }